/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Tab_RoundsInputs */



/**
* | output |
* | --- |
* | "Rounds" |
*
* @param {Tournament_Tab_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_tab_rounds = /** @type {((inputs?: Tournament_Tab_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Tab_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round")
	return /** @type {LocalizedString} */ ("Rounds")
});